import React from 'react';
import PropTypes from 'prop-types';
import ProductRow from './ProductRow';
import './PriceGridTable.scss';

const propTypes = {
    productPrices: PropTypes.array,
};

export default class PriceGridTable extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {productPrices} = this.props;
        return(
            <div className='price-grit-holder'>
                <table className='price-grit-table'>
                    <thead>
                        <tr className='price-grit-row'>
                            <td className='price-grid-cell'>UPC</td>
                            <td className='price-grid-cell'>PRODUCT CODE</td>
                            <td className='price-grid-cell'>PRODUCT DESCRIPTION</td>
                            <td className='price-grid-cell'>SRP $</td>
                            <td className='price-grid-cell'>MAP $</td>
                        </tr>
                    </thead>
                    <tbody>
                    {this.props.productPrices.map((product, index) => (
                        <ProductRow key={index} product={product}/>
                    ))}
                    </tbody>

                </table>
            </div>
        );
    }
}

PriceGridTable.propTypes = propTypes;


// WEBPACK FOOTER //
// ./src/components/PriceGridTable/index.js